var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFbiconwhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 23,
    viewBox: "0 0 24 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 11.5751C24 5.1822 18.6277 0 12.0015 0C5.37233 0.0014379 0 5.1822 0 11.5766C0 17.3526 4.38845 22.1408 10.1237 23.0093V14.9211H7.07911V11.5766H10.1267V9.02428C10.1267 6.12403 11.919 4.5222 14.6592 4.5222C15.973 4.5222 17.3453 4.74795 17.3453 4.74795V7.595H15.832C14.3427 7.595 13.8778 8.48794 13.8778 9.40388V11.5751H17.2043L16.6734 14.9197H13.8763V23.0079C19.6115 22.1394 24 17.3512 24 11.5751Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFbiconwhite);
export default __webpack_public_path__ + "static/media/fbiconwhite.6d1d255438983b6a08efff50d77b5c48.svg";
export { ForwardRef as ReactComponent };